import { Container, Paper, Typography } from '@mui/material';
import type { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';

import Auth from '../../api/auth';
import FormikForm from '../../components/Formik/Form/FormikForm';
import { enqueueSnackbar } from '../../redux/notifier/actions';

const PasswordReset: FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fields = [
    {
      fieldType: 'text',
      name: 'email',
      label: intl.formatMessage({ id: 'emailAddress' }),
      placeholder: 'example@pan-net.eu',
    },
  ];

  const initialValues = {
    email: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required(intl.formatMessage({ id: 'formRequiredError' }))
      .email(intl.formatMessage({ id: 'invalidEmailError' })),
  });

  const handleSubmit = async (data: Record<string, unknown>): Promise<void> => {
    try {
      await Auth.resetUserPasswordLink(data);
      dispatch(
        enqueueSnackbar({
          message: 'userPasswordResetEmail',
          options: { variant: 'success' },
        })
      );
      navigate('/');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'genericErrorOccurred';
      dispatch(
        enqueueSnackbar({
          message: errorMessage,
          options: { variant: 'error' },
        })
      );
    }
  };

  return (
    <Container maxWidth='sm'>
      <Paper style={{ padding: '2.125rem' }}>
        <Typography
          align='center'
          variant='h4'
          color='primary'
        >
          {intl.formatMessage({ id: 'resetPasswordTitle' })}
        </Typography>
        <Typography align='center'>
          {intl.formatMessage({ id: 'resetPasswordInstructions' })}
        </Typography>
        <FormikForm
          fields={fields}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={data => {
            handleSubmit(data).catch((error: unknown) => {
              console.error('Error during form submission:', error);
            });
          }}
          submitLabel={intl.formatMessage({ id: 'resetPasswordTitle' })}
        />
      </Paper>
    </Container>
  );
};

export default PasswordReset;
